import React from "react";
import { useUID } from "react-uid";

export default function Hide({ color, size }) {
  const id = useUID();
  const svgSize = size === "sm" ? 12 : 24;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={svgSize}
      height={svgSize}
      viewBox="0 0 24 24"
    >
      <defs>
        <path
          id={id}
          d="M.293.293a.999.999 0 0 1 1.414 0l22 22a.999.999 0 1 1-1.414 1.414l-4.466-4.466A10.993 10.993 0 0 1 12.016 21C4.469 21 .28 12.796.105 12.447a1 1 0 0 1 .014-.92c1.14-2.124 2.653-3.965 4.468-5.526L.293 1.707a.999.999 0 0 1 0-1.414zm5.709 7.123a17.27 17.27 0 0 0-3.858 4.585C3.083 13.613 6.626 19 12 19a8.952 8.952 0 0 0 4.367-1.219l-2.328-2.328a3.973 3.973 0 0 1-2.117.622 3.975 3.975 0 0 1-2.724-1.074 3.971 3.971 0 0 1-1.27-2.785 3.97 3.97 0 0 1 .609-2.265zm5.657-4.421l.343.005c7.529 0 11.718 8.204 11.893 8.553.144.29.14.633-.013.919a19.568 19.568 0 0 1-2.276 3.362 1.003 1.003 0 0 1-1.41.122 1.001 1.001 0 0 1-.122-1.41A17.546 17.546 0 0 0 21.857 12c-.94-1.611-4.482-7-9.857-7-.605.034-1.26.07-1.872.214a1 1 0 1 1-.456-1.947c.762-.178 1.523-.301 2.33-.267zm-1.627 8.451a2.007 2.007 0 0 0-.106.7c.019.533.245 1.028.636 1.392.392.364.92.56 1.434.535.192-.007.377-.049.555-.108z"
        />
      </defs>
      <use fill={color} fillRule="evenodd" xlinkHref={`#${id}`} />
    </svg>
  );
}
